/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Medicine14Inputs */

const en__field__enum_studyprograms_study_medicine14 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Medicine14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medicine`)
};

const de__field__enum_studyprograms_study_medicine14 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Medicine14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medizin`)
};

/**
* | output |
* | --- |
* | "Medicine" |
*
* @param {_Field__Enum_Studyprograms_Study_Medicine14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_medicine14 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Medicine14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Medicine14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_medicine14(inputs)
	return de__field__enum_studyprograms_study_medicine14(inputs)
});
export { _field__enum_studyprograms_study_medicine14 as "_field__enum_studyPrograms_STUDY_MEDICINE" }